import axios from "axios";
import store from "../store";

let transport;

export const configureTransport = (token = null) => {
  if (!transport) {
    transport = axios.create({
      baseURL: import.meta.env.VITE_API_URL,
      withCredentials: true,
    });
  }

  const state = store.getState();
  const accessToken = token || state?.auth?.accessToken || "";

  if (accessToken) {
    transport.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  } else {
    delete transport.defaults.headers.common["Authorization"];
  }

  return transport;
};

export const getTransport = () => transport || configureTransport();
